<sh-control *ngIf="control" [control]="this">
  <p-autoComplete
    fluid
    styleClass="w-100 {{ class }}"
    [inputId]="id ?? ''"
    [appendTo]="appendTo"
    [autoHighlight]="autoHighlight"
    [completeOnFocus]="openOnFocus"
    [disabled]="disabled || isDisabled"
    [forceSelection]="forceSelection"
    [multiple]="multiple ? true : false"
    [field]="itemLabel ?? ''"
    [placeholder]="placeholder ?? ''"
    [readonly]="readonly"
    [suggestions]="items ?? []"
    [minLength]="minLength"
    [(ngModel)]="inputValue"
    [showEmptyMessage]="true"
    [emptyMessage]="'shared.terms.noResults' | translate"
    (completeMethod)="search($event)"
    (onBlur)="blurred()"
  >
    <ng-template pTemplate="item" let-option>
      <ng-container *ngIf="itemTemplate; else defaultItem">
        <ng-container
          *ngTemplateOutlet="itemTemplate; context: { $implicit: option }"
        ></ng-container>
      </ng-container>

      <ng-template #defaultItem>
        {{ option?.[itemLabel ?? ''] ?? option }}
      </ng-template>
    </ng-template>

    <ng-template pTemplate="selectedItem" let-value>
      {{ value?.[itemLabel ?? ''] ?? value }}
    </ng-template>

    <ng-template pTemplate="header">
      <ng-container *ngIf="headerTemplate && items.length > 0">
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      </ng-container>
    </ng-template>

    <ng-template pTemplate="footer">
      <ng-container *ngIf="footerTemplate">
        <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
      </ng-container>
    </ng-template>
  </p-autoComplete>
</sh-control>
